import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const Stat = ({ label, value, testid }) => (
  <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
    <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500">{label}</div>
    <div className="font-display text-2xl font-black text-[color:var(--mv-navy)] mt-0.5" data-testid={testid}>{value}</div>
  </div>
);

export const MyWeek = ({ authFetch, refreshKey }) => {
  const [data, setData] = useState(null);
  const [showPast, setShowPast] = useState(false);

  useEffect(() => {
    authFetch('get', '/driver/history').then(({ data }) => setData(data)).catch(() => {});
  }, [authFetch, refreshKey]);

  if (!data) return null;
  const w = data.week;
  return (
    <section className="mb-6 rounded-xl border border-slate-200 bg-white p-5" data-testid="driver-my-week">
      <div className="text-[10px] uppercase tracking-wider font-bold text-slate-500">My week</div>
      <h2 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)]">Since Monday</h2>
      <div className="mt-3 grid grid-cols-3 gap-2">
        <Stat label="Jobs done" value={`${w.jobs_done}/${w.scheduled}`} testid="my-week-jobs" />
        <Stat label="Hours worked" value={w.hours % 1 ? w.hours.toFixed(1) : w.hours} testid="my-week-hours" />
        <Stat label="Collected" value={`£${w.collected}`} testid="my-week-collected" />
      </div>
      {w.expenses && w.expenses.submitted > 0 && (
        <div className="mt-2 rounded-lg bg-amber-50 border border-amber-200 p-3 text-xs text-amber-900 flex flex-wrap gap-x-4 gap-y-1" data-testid="my-week-expenses">
          <span>Expenses claimed <strong data-testid="my-week-exp-submitted">£{w.expenses.submitted.toFixed(2)}</strong></span>
          <span>Approved <strong data-testid="my-week-exp-approved">£{w.expenses.approved.toFixed(2)}</strong></span>
          <span>Reimbursed <strong data-testid="my-week-exp-reimbursed">£{w.expenses.reimbursed.toFixed(2)}</strong></span>
          {w.expenses.pending_count > 0 && <span>{w.expenses.pending_count} awaiting approval</span>}
        </div>
      )}
      <button type="button" onClick={() => setShowPast(v => !v)} className="mt-3 h-11 inline-flex items-center gap-1 text-sm font-bold text-[color:var(--mv-orange)]" data-testid="my-week-past-toggle">
        {showPast ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />} Past jobs ({data.past.length})
      </button>
      {showPast && (
        <div className="divide-y divide-slate-100" data-testid="my-week-past-list">
          {data.past.length === 0 && <div className="py-2 text-xs text-slate-500">No past jobs yet.</div>}
          {data.past.map(p => (
            <div key={p.id} className="py-2 flex items-center justify-between gap-2 text-sm">
              <div className="min-w-0">
                <div className="font-bold text-[color:var(--mv-navy)] truncate">{p.booking?.date} · {p.name}</div>
                <div className="text-xs text-slate-500 truncate">#{p.ref} · {p.from_postcode || '—'} → {p.to_postcode || '—'} · {p.hours_estimate || '—'}</div>
              </div>
              <span className={`shrink-0 text-[10px] font-black uppercase px-2 py-0.5 rounded-full ${p.completed_at ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'}`}>{p.completed_at ? 'Done' : 'Not marked'}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
